<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      class="mb-4"
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      field-name="사업장명(필수)"
      :options="[
        { type: 'date', label: '조사일(필수)', value: '조사일' },
        { type: 'text', label: '조사자', value: '조사자' },
        { type: 'text', label: '공정명', value: '공정명' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
    />

    <!--  구분 -->
    <div>
      <h5><i class="dot"></i> 조사 구분</h5>
      <div class="grid grid-cols-4 mt-4">
          <div>
            <vs-checkbox v-for="value in ['정기조사']"
                         class="mr-6"
                         :checked="form.regularly === value"
                         @change="form.regularly = form.regularly === value ? '' : value ">
              {{value}}
            </vs-checkbox>
          </div>
          <div>
            <vs-checkbox v-for="value in ['수시조사 - 근골격계 질환자 발생 시', '수시조사 - 새로운 작업 및 설비 도입 시', '수시조사 - 업무의 양과 작업공정 등 작업환경 변경 시']"
                         class="mr-6 mb-2"
                         :checked="form.regularly === value"
                         @change="form.regularly = form.regularly === value ? '' : value ">
              {{value}}
            </vs-checkbox>
          </div>
      </div>
    </div>

    <!-- 근골격계부담작업 -->
    <MusculoskeletalTensionExercisesTable v-model="form.table" :readonly="board.readonly" :is-print="isPrint" class="mt-28px" title="단위작업별 근골격계부담작업 선정 결과" :initial-empty-rows="1" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import MusculoskeletalTensionExercisesTable from "@/views/boards/single-page/293/MusculoskeletalTensionExercisesTable";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    MusculoskeletalTensionExercisesTable,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object | undefined,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
        조사일: { required },
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        regularly: "",
        fileList: [],
        table: [],
      },
    };
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) {
          alert("사업장명을 반드시 입력해야 합니다");
        } else if (!this.$v.form.stdInfo["조사일"].required) {
          alert("조사일을 반드시 입력해야 합니다");
        } else if (!this.$v.form.stdInfo["재해형태"].required) {
          alert("재해형태를 반드시 입력해야 합니다");
        }

        return false;
      } else {
        // 유효성 검사가 성공한 경우
        return true;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
